import { Node } from 'slate';
import { ReactEditor } from 'slate-react';

export const getLinkSesTags = (editor, node) => {
    const buttonText = Node.string(node);
    const buttonPath = ReactEditor.findPath(editor, node).toString();
    const href = node.attributes.href || '';
    return {
        'ses:tags': `text:${buttonText};url:${href};path:${buttonPath}`,
        id: buttonPath,
    };
};
